import React from 'react';
import { Stack, Typography } from '@mui/material';
import MessageHeaderBlock from './MessageHeaderBlock';
import FormattedText from './FormattedText';
import MessageActionButtons from './MessageActionButtons';
import useMessageStyles from '../../../hooks/useMessageStyles';

export default function ButtonsMessage({ message }) {
  const { messageFooterSx, messageRichStackSx } = useMessageStyles();
  const { header, text, footer, buttons } = message;

  return (
    <Stack spacing={0} sx={messageRichStackSx}>
      <MessageHeaderBlock header={header} bleed />

      {text && <FormattedText text={text} />}

      {footer && (
        <Typography variant="caption" sx={messageFooterSx}>
          {footer}
        </Typography>
      )}

      <MessageActionButtons buttons={buttons} disabled />
    </Stack>
  );
}
